"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
var _material = require("@mui/material");
var theme = exports.theme = (0, _material.createTheme)({
  palette: {
    primary: {
      main: "#6B9C50"
    },
    error: {
      main: "#D0241E"
    },
    action: {
      disabled: "#CCCCCC"
    },
    purple: {
      main: "#8073AC"
    },
    warning: {
      main: "#D58344"
    }
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: function root(_ref) {
          var theme = _ref.theme;
          return {
            color: theme.palette.primary.main,
            "& .MuiCheckbox-root": {
              color: theme.palette.primary.main
            }
          };
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: function root(_ref2) {
          var theme = _ref2.theme,
            ownerState = _ref2.ownerState;
          return {
            backgroundColor: function () {
              switch (ownerState.severity) {
                case "error":
                  return theme.palette.error.main;
                case "warning":
                  return theme.palette.warning.main;
                case "info":
                  return "#2196f3";
                case "success":
                  return theme.palette.primary.main;
                default:
                  return theme.palette.primary.main;
              }
            }(),
            color: function () {
              if (ownerState.severity === "success") {
                return "#333333";
              }
              return "white";
            }()
          };
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: function root() {
          return {
            fontFamily: "Open Sans, sans-serif"
          };
        }
      }
    }
  },
  typography: {
    button: {
      textTransform: "none",
      fontFamily: "Open Sans, sans-serif"
    }
  }
});
document.documentElement.style.setProperty("--primary-main", theme.palette.primary.main);
document.documentElement.style.setProperty("--error-main", theme.palette.error.main);
document.documentElement.style.setProperty("--action-disabled", theme.palette.action.disabled);
document.documentElement.style.setProperty("--teams-main", "#8073AC");